export default function Features() {
  return (
    <section id="features" className="py-32 bg-gradient-to-b from-blue-50/50 to-white">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="text-center mb-20">
          <h2 className="text-6xl font-bold text-gray-900 mb-2">Why Choose</h2>
          <h2 className="text-6xl font-bold bg-gradient-to-r from-cyan-500 to-blue-600 bg-clip-text text-transparent">
            STYLINE VPN
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Large Left Card */}
          <div className="lg:row-span-2 relative overflow-hidden rounded-3xl shadow-2xl h-[700px] group">
            <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900">
              {/* Animated Network Pattern */}
              <div className="absolute inset-0 opacity-30">
                <div className="absolute top-10 left-10 w-3 h-3 bg-cyan-400 rounded-full animate-pulse"></div>
                <div className="absolute top-20 right-20 w-2 h-2 bg-blue-400 rounded-full animate-pulse delay-100"></div>
                <div className="absolute bottom-32 left-32 w-2 h-2 bg-cyan-400 rounded-full animate-pulse delay-200"></div>
                <div className="absolute bottom-20 right-16 w-3 h-3 bg-blue-400 rounded-full animate-pulse delay-300"></div>
              </div>
            </div>

            <div className="absolute bottom-0 left-0 p-12">
              <div className="w-20 h-20 flex items-center justify-center mb-6">
                <i className="ri-shield-check-fill text-7xl text-white" style={{ filter: 'drop-shadow(0 0 20px rgba(6, 182, 212, 0.8))' }}></i>
              </div>
              <h3 className="text-4xl font-bold text-white mb-4">Military-Grade Encryption</h3>
              <p className="text-lg text-gray-300 leading-relaxed">
                AES-256 encryption protects your data from any threat. Your online activities remain completely private and secure.
              </p>
            </div>
          </div>

          {/* Top Right Card */}
          <div className="relative overflow-hidden rounded-3xl shadow-xl h-[340px] bg-gradient-to-br from-cyan-100 to-white group hover:shadow-2xl transition-shadow duration-300">
            <div className="p-12 h-full flex flex-col justify-center">
              <div className="w-16 h-16 flex items-center justify-center mb-6">
                <i className="ri-flashlight-fill text-6xl text-blue-600"></i>
              </div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4">Ultra-Fast Speeds</h3>
              <p className="text-base text-gray-700 leading-relaxed">
                No throttling, no buffering, just pure speed. Stream, download, and browse without any limitations.
              </p>
            </div>
          </div>

          {/* Bottom Right Card */}
          <div className="relative overflow-hidden rounded-3xl shadow-xl h-[340px] bg-gradient-to-br from-purple-100 via-pink-50 to-white group hover:shadow-2xl transition-shadow duration-300">
            <div className="p-12 h-full flex flex-col justify-center">
              <div className="w-16 h-16 flex items-center justify-center mb-6">
                <i className="ri-global-line text-6xl text-purple-700"></i>
              </div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4">Global Server Network</h3>
              <p className="text-base text-gray-700 leading-relaxed">
                Connect to optimized servers across 50+ countries. Access content from anywhere with reliable, high-speed connections.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
